import { Body1, makeStyles, mergeClasses, Subtitle1, tokens } from '@fluentui/react-components'
import { InfoRegular } from '@fluentui/react-icons'

import commonStyles from '../styles/common.styles'

const useStyles = makeStyles({
  root: {
    ...commonStyles.flexColumn8,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '240px',
  },
  icon: {
    ...commonStyles.flexRow2,
    justifyContent: 'center',
    height: '64px',
    width: '64px',
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorPaletteRoyalBlueBorderActive,
    marginBottom: tokens.spacingVerticalXXL,
  },
})

interface InfoLayoutProps {
  title?: string
  message?: string
  className?: string
}

export function InfoLayout({ title, message, className }: InfoLayoutProps) {
  const styles = useStyles()

  return (
    <div className={mergeClasses(styles.root, className)}>
      <div className={styles.icon}>
        <InfoRegular fontSize={48} />
      </div>
      <Subtitle1 align="center">{title || 'Information'}</Subtitle1>
      <Body1 align="center" style={{ color: tokens.colorNeutralForeground2 }}>
        {message || 'No additional information is available.'}
      </Body1>
    </div>
  )
}
